import React from 'react';
import { Bell } from 'lucide-react';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent } from './ui/dropdown-menu';
import { useNotifications } from '../context/NotificationContext';
import NotificationItem from './NotificationItem';

const NotificationDropdown = () => {
  const { notifications, unreadCount, markAllAsRead, clearAllNotifications } = useNotifications();

  const handleMarkAllAsRead = () => {
    markAllAsRead();
  };

  const handleClearAll = () => {
    clearAllNotifications();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="relative p-1 rounded-full text-gray-600 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
          aria-label="Notifications"
        >
          <Bell className="h-6 w-6" />
          {unreadCount > 0 && (
            <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white transform translate-x-1/2 -translate-y-1/2 bg-red-500 rounded-full">
              {unreadCount > 9 ? '9+' : unreadCount}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-80 p-0">
        <div className="px-4 py-3 border-b border-gray-200 bg-primary-50">
          <div className="flex justify-between items-center">
            <h3 className="text-sm font-semibold text-gray-800">Notifications</h3>
            <div className="flex space-x-2">
              <button
                onClick={handleMarkAllAsRead}
                className="text-xs text-primary hover:text-primary-dark flex items-center"
                disabled={unreadCount === 0}
              >
                Mark all read
              </button>
              <button
                onClick={handleClearAll}
                className="text-xs text-gray-600 hover:text-gray-800 flex items-center"
                disabled={notifications.length === 0}
              >
                Clear all
              </button>
            </div>
          </div>
        </div>

        <div className="max-h-80 overflow-y-auto">
          {notifications.length > 0 ? (
            notifications.map(notification => (
              <NotificationItem
                key={notification.id}
                notification={notification}
              />
            ))
          ) : (
            <div className="py-6 text-center text-gray-500">
              <p>No notifications</p>
            </div>
          )}
        </div>

        <div className="px-4 py-2 border-t border-gray-200 bg-gray-50">
          <a
            href="/notifications"
            className="block text-center text-sm text-primary hover:text-primary-dark"
          >
            View all notifications
          </a>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default NotificationDropdown;
